import { useSitrepSectionWizardContext } from '../SitrepSectionWizardContext';
import StylishNewInput from '../../../DesignSystems/New/StylishNewInput';
import StylishNewTextArea from '../../../DesignSystems/New/StylishNewTextArea';

/** This component allows the user to set the section name and AI prompt. */
const Section = () => {
  const { sectionName, setSectionName, aiPrompt, setAiPrompt } =
    useSitrepSectionWizardContext();
  return (
    <>
      <h4>Section Name:</h4>
      <StylishNewInput
        className="section-name-input"
        value={sectionName}
        onChange={(event) => setSectionName(event.currentTarget.value)}
      />
      <h4>AI Prompt:</h4>
      <StylishNewTextArea
        className="border-white"
        value={aiPrompt}
        onChange={(event) => setAiPrompt(event.currentTarget.value)}
      />
    </>
  );
};

export default Section;
